import styled, { keyframes } from 'styled-components'

interface AutoSavingContainerProps {
  hasError?: boolean;
}

export const AutoSavingContainer = styled.div<AutoSavingContainerProps>`
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 2px 10px;

  box-shadow: 0px 5px 15px #00000066;
  border-radius: 20px;
  background-color: ${({ hasError }) => (hasError ? '#FDEBEB' : '#FFFFFF')};
`

interface AutoSavingTextProps{
  hasError?: boolean;
}

export const AutoSavingText = styled.div<AutoSavingTextProps>`
  p{
    color: ${({ hasError }) => (hasError ? '#FF4949' : '#4B4B4B')};
  }
`

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinnerContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;

  svg {
    animation: ${spinAnimation} 1s linear infinite;
  }
`
